export default __webpack_public_path__ + "static/contact-large-0fb796476516f97fdb25e50828301e08.webp";